import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { ScriptLoaderService, ScriptModel } from './script-loader.service';
declare var ka: any;

@Injectable({
  providedIn: 'root'
})
export class KountService {

  constructor(public scriptLoader: ScriptLoaderService) { }

  public loadScript(scriptId: string, sessionId?: string): Observable<ScriptModel> {
    const scriptSrc =  `${environment.KOUNT_URL}?m=${environment.KOUNT_MERCHANT_ID}` + (sessionId ? `&s=${sessionId}`: '');
    return this.scriptLoader.load({id: scriptId, src: scriptSrc, loaded: false});
  }
  
  public collectFraudData() {
    if(ka) {
      var client= new ka.ClientSDK();
      window['kountClient'] = client;  
      client.autoLoadEvents();
    }
  }
}
